// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"ac1aed35","73":"69f831b2","481":"ac1aed35","624":"a17253f8","658":"8ec3edc1","659":"06322830","795":"cd33439d","796":"a34a891c","849":"06322830"}[chunkId] + ".chunk.css";
};